import LoyaltyCardsServices from '@/services/loyaltyCards'
import StoreLoyaltyCardServices from '@/services/storeLoyaltyCard'
import EnvironmentUtils from '@/utils/environmentUtils'

async function initFrame (store)
{
    const token = store.state.user.token
    if (!token) return;
    
    LoyaltyCardsServices.fetchUserCard(EnvironmentUtils.cityId, token, store.state.user.accountId).then(card  =>
    {
        store.commit('loyaltyCard/setCard', card)

        for (const b of card.balance)
        {
            StoreLoyaltyCardServices.fetchStoreCardConfig(EnvironmentUtils.cityId, b.storeId).then(config  =>
            {
                store.commit('storeLoyaltyCard/setStoreConfig', config)
            })
        }
        LoyaltyCardsServices.fetchCardLatestCredits(EnvironmentUtils.cityId, token, card.cardId).then(list  =>
        {
            store.commit('loyaltyCard/updateLatestCredits', list)
        })
        LoyaltyCardsServices.fetchCardLatestRewards(EnvironmentUtils.cityId, token, card.cardId).then(list  =>
        {
            store.commit('loyaltyCard/updateLatestRewards', list)
        })
    })
}


export default { initFrame }


// WEBPACK FOOTER //
// ./src/frames/loyaltyCardFrame.js